import { useEppoFeatureFlag } from '@/context/hooks/useInitializeEppo';

import { Conversation } from './Conversation';
import { ConversationV2 } from './ConversationV2';

export function ConversationRouter() {
  const { value: showThreadImprovements } = useEppoFeatureFlag({
    featureFlag: 'thread_improvements',
    flagType: 'boolean',
    defaultValue: false,
  });

  return showThreadImprovements ? <ConversationV2 /> : <Conversation />;
}
